import {TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';
import {Store} from "@ngrx/store";
import {IRootState, selectLanguage} from "@app/store";

export function translateInitializerFactory(translate: TranslateService, _store: Store<IRootState>) {
  return async () => {

    const storedLang = await firstValueFrom(_store.select(selectLanguage));
    const browserLang = translate.getBrowserLang() ?? 'ru';

    const lang = storedLang ? storedLang : browserLang;
    console.log(
      `%c Default language: ${lang} `,
      'font-weight: bold; ' +
      'color: cyan; ' +
      'background-color: #1e40af; ' +
      'padding: 6px 16px; ' +
      'display: block; ' +
      'width: 100%; ' +
      'box-sizing: border-box; ' +
      'margin: 0;'
    );
    return firstValueFrom(translate.use(lang));
  };
}
